
import ApiService from "@/core/services/ApiService";
import { defineComponent, onMounted, reactive } from "vue";
import { Modal } from "bootstrap";
import { useToast } from "vue-toastification";
import Multiselect from "@vueform/multiselect";
import { Field } from "vee-validate";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Vue3TagsInput from "vue3-tags-input";

export default defineComponent({
  name: "ListBarcode",
  components: {
    Loading,
    Field,
    Multiselect,
    Vue3TagsInput,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      isLoading: false,
      isColor: "#007BFF",
      isBackgroundColor: "#A3A3A3",
      tableData: [],
      cardData: [],
      searchNIS: "",
      searchNama: "",
      pagingModal: {
        page: 0,
        totalPages: 1,
        size: 10,
        totalElements: 0,
        perPageOptions: [10, 25, 50, 100],
      },
      paging: {
        page: 0,
        totalPages: 1,
        size: 10,
        totalElements: 0,
        perPageOptions: [10, 25, 50, 100],
      },
      showGenerateModal: false,
      generateOption: "semua",
      selectedItems: [] as any[],
      selectedItemsGenerate: [] as any[],
      allSelected: false,
      allSelectedGenerate: false,
      schoolId: "",
      listItems: <any>[],
      filterModal: {
        nis: [],
        name: "",
        tag: [],
      },
      nis: [],
      name: "",
      tag: [],
      previewImageUrl: "",
      barcode: "",
      tagList: <any[]>[],
    };
  },

  watch: {
    tag: function () {
      this.getData(this.paging.size, this.paging.page);
    },
    "filterModal.tag": function () {
      this.getCardData(this.pagingModal.size, this.pagingModal.page);
    },
  },

  beforeMount() {
    const store = useStore();
    store.dispatch(Actions.VERIFY_AUTH_FINANCE);

    const userAccount = localStorage.getItem("user_account");
    this.schoolId = userAccount ? JSON.parse(userAccount).schoolId : "";
    this.getTags();
    this.getData(this.paging.size, this.paging.page);
  },
  computed: {
    from() {
      return this.paging.size * this.paging.page;
    },
    to() {
      const from = this.paging.size * this.paging.page;
      let highBound = from + this.paging.size;
      if (this.paging.totalElements < highBound) {
        highBound = this.paging.totalElements;
      }
      return highBound;
    },
  },
  methods: {
    async getTags() {
      this.tagList = [];
      if (!this.schoolId) return;
      try {
        let response = await ApiService.getWithoutSlug(
          "crmv2/main_card/card_data/office/" + this.schoolId + "/combo/tag"
        );
        console.log;
        this.tagList = response.data.data;
      } catch (error) {
      } finally {
      }
    },
    getCardData(size, page) {
      this.cardData = [];
      this.pagingModal.page = 0;
      this.pagingModal.size = 10;
      this.pagingModal.totalElements = 0;
      this.pagingModal.totalPages = 0;

      if (!this.schoolId) return;
      let nis = "";
      let name = "";
      let tag = "";

      if (this.filterModal.nis) nis = "&nis=" + this.filterModal.nis.join(",");
      if (this.filterModal.name) name = "&name=" + this.filterModal.name;
      if (this.filterModal.tag) tag = "&tag=" + this.filterModal.tag.join(",");

      this.isLoading = true;
      ApiService.getWithoutSlug(
        "crmv2/main_card/card_data/barcode/generate?schoolId=" +
          this.schoolId +
          "&page=" +
          page +
          nis +
          name +
          tag +
          "&size=" +
          size +
          "&sort=name&dir=1"
      )
        .then(({ data }) => {
          this.cardData = data.data;
          this.pagingModal.page = data.page;
          this.pagingModal.size = data.size;
          this.pagingModal.totalElements = data.totalElements;
          this.pagingModal.totalPages = data.totalPages;
          this.isLoading = false;
          if (this.allSelectedGenerate) {
            // Tambahkan data baru ke selectedItemsGenerate tanpa menghapus data sebelumnya
            data.data.forEach((item) => {
              if (
                !this.selectedItemsGenerate.some(
                  (selected) => selected._id === item._id
                )
              ) {
                this.selectedItemsGenerate.push(item);
              }
            });
          }
          if (!this.showGenerateModal) {
            this.onGenerate();
          }
        })
        .catch(({ response }) => {
          this.isLoading = false;
        });
    },
    getData(size, page) {
      this.listItems = [];
      this.paging.page = 0;
      this.paging.size = 10;
      this.paging.totalElements = 0;
      this.paging.totalPages = 0;

      if (!this.schoolId) return;
      let nis = "";
      let name = "";
      let tag = "";

      if (this.nis) nis = "&nis=" + this.nis.join(",");
      if (this.name) name = "&name=" + this.name;
      if (this.tag) tag = "&tag=" + this.tag.join(",");

      this.isLoading = true;
      ApiService.getWithoutSlug(
        "crmv2/main_card/card_data/barcode/?schoolId=" +
          this.schoolId +
          "&page=" +
          page +
          nis +
          name +
          tag +
          "&size=" +
          size +
          "&sort=name&dir=1"
      )
        .then(({ data }) => {
          this.listItems = data.data;
          localStorage.setItem("listData", JSON.stringify(data.content));
          this.paging.page = data.page;
          this.paging.size = data.size;
          this.paging.totalElements = data.totalElements;
          this.paging.totalPages = data.totalPages;
          this.pagingModal.page = data.page;
          this.pagingModal.size = data.size;
          this.pagingModal.totalElements = data.totalElements;
          this.pagingModal.totalPages = data.totalPages;
          this.isLoading = false;
        })
        .catch(({ response }) => {
          this.isLoading = false;
        });
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedItems = [...this.listItems];
      } else {
        this.selectedItems = [];
      }
    },
    toggleSelectAllGenerate() {
      if (this.allSelectedGenerate) {
        this.selectedItemsGenerate = [...this.cardData];
      } else {
        this.selectedItemsGenerate = [];
      }
    },
    handleChangeNis(nis) {
      this.nis = nis;
      this.getData(this.paging.size, this.paging.page);
    },
    handleChangeNisModal(nis) {
      this.filterModal.nis = nis;
      this.getCardData(this.pagingModal.size, this.pagingModal.page);
    },
    onSearch() {
      // implement search logic here
    },
    async previewBarcode(item) {
      // async refreshImage(image, index = -1) {
      try {
        this.isLoading = true;

        let response = await ApiService.getDownload(
          "crmv2/main_image/image/get/" + item.barcode_url
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        this.previewImageUrl = url;
        this.barcode = item.barcode;
        this.isLoading = false;
        const modal = new Modal(
          document.getElementById("kt_modal_preview_barcode")
        );
        modal.show();
      } catch (error) {}
      // },
    },
    async downloadBarcode(item) {
      try {
        this.isLoading = true;
        let response = await ApiService.getDownload(
          "crmv2/main_image/image/get/" + item.barcode_url
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `barcode_nis_${item.nis || "download"}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.isLoading = false;
      } catch (error) {
        // handle error if needed
      }
    },
    async downloadAllBarcode() {
      if (!this.schoolId) return;
      let nis = "";
      let name = "";
      let tag = "";

      if (this.nis) nis = this.nis.join(",");
      if (this.name) name = this.name;
      if (this.tag) tag = this.tag.join(",");
      try {
        this.isLoading = true;
        const response = await ApiService.getDownload(
          `crmv2/main_image/card/office/barcode/${this.schoolId}?nis=${nis}&name=${name}&tag=${tag}`
        );
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `barcodes.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        // handle error if needed
      }
    },
    changePageSizeModal() {
      const page = this.pagingModal.page;
      this.getCardData(this.pagingModal.size, page);
    },
    changePageSize() {
      const page = this.paging.page;
      this.getData(this.paging.size, page);
    },
    prevPage() {
      const page = this.paging.page - 1;
      this.getData(this.paging.size, page);
    },
    nextPage() {
      const page = this.paging.page + 1;
      this.getData(this.paging.size, page);
    },
    prevPageModal() {
      const page = this.pagingModal.page - 1;
      this.getCardData(this.pagingModal.size, page);
    },
    nextPageModal() {
      const page = this.pagingModal.page + 1;
      this.getCardData(this.pagingModal.size, page);
    },
    changePage(item) {
      const page = item - 1;
      this.getData(this.paging.size, page);
    },
    onCancel() {
      this.$router.push({ path: "/sekolah/card-design" });
    },
    onCancelGenerate() {
      this.showGenerateModal = false;
      this.selectedItemsGenerate = [];
      this.allSelectedGenerate = false;
      this.generateOption = "semua";
    },
    onGenerate() {
      const modal = new Modal(document.getElementById("kt_modal_generate"));
      modal.show();
      this.showGenerateModal = true;
    },
    handleGenerate() {
      const toast = useToast();

      if (
        this.selectedItemsGenerate.length === 0 &&
        this.generateOption === "sebagian"
      ) {
        toast.error("Pilih kartu yang akan digenerate");
        return;
      }

      let cardId = this.selectedItemsGenerate.map((prop) => {
        return prop._id;
      });
      let data = {
        schoolId: this.schoolId,
        nis: this.filterModal.nis.length ? this.filterModal.nis.join(",") : "",
        name: this.filterModal.name,
        tag: this.filterModal.tag.length ? this.filterModal.tag.join(",") : "",
        cardIds: cardId,
      };

      this.isLoading = true;
      ApiService.postWithData(
        "crmv2/main_card/card_data/barcode/generate",
        data
      )
        .then(({ data }) => {
          this.isLoading = false;
          toast.success(data.message);
          const modal = Modal.getInstance(
            document.getElementById("kt_modal_generate")
          );
          if (modal) {
            modal.hide();
          }
          this.getData(this.paging.size, this.paging.page);
        })
        .catch(({ response }) => {
          this.isLoading = false;
        });
    },
  },
});
